import "core-js/modules/es.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Notice from "./";
import { dispute } from "../Icon/Assets";

var AttentionNotice = function AttentionNotice(props) {
  return /*#__PURE__*/React.createElement(Notice, _extends({}, props, {
    color: "yellow",
    icon: dispute
  }));
};

export default AttentionNotice;